const client = {
  apiClient: null,
  path: '/',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async getStates() {
    try {
      const response = await this.apiClient.get(this.path + `states`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getPetTypes() {
    try {
      const response = await this.apiClient.get(this.path + `pet-types`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getFrequencies() {
    try {
      const response = await this.apiClient.get(this.path + `frequencies`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getDietCategories() {
    try {
      const response = await this.apiClient.get(this.path + `diet-categories`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getDietStages() {
    try {
      const response = await this.apiClient.get(this.path + `diet-stages`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getDietTypes() {
    try {
      const response = await this.apiClient.get(this.path + `diet-types`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getProducts() {
    try {
      const response = await this.apiClient.get(this.path + `products`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getProductCategories() {
    try {
      const response = await this.apiClient.get(this.path + `product-categories`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getProductById(id) {
    try {
      const response = await this.apiClient.get(this.path + `product/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getIncomeCategories() {
    try {
      const response = await this.apiClient.get(this.path + `income-categories`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getExpenseCategories() {
    try {
      const response = await this.apiClient.get(this.path + `expense-categories`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCarriers() {
    try {
      const response = await this.apiClient.get(this.path + `carriers`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getPetCheckupAttributes() {
    try {
      const response = await this.apiClient.get(this.path + `pet-checkup-attributes`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default client;
